export default "__VITE_PUBLIC_ASSET__12ac81f4__"